import { Link2Icon } from "@radix-ui/react-icons";
import { Button } from "@/components/ui";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "@/components/ui/Dialog";
import { TextFilePreview } from "./TextFilePreview";

interface FilePreviewDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  previewItem: any;
  previewType: "image" | "text" | "other";
}

export function FilePreviewDialog({
  isOpen,
  onOpenChange,
  previewItem,
  previewType,
}: FilePreviewDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-4xl max-h-[90vh] overflow-hidden">
        <DialogTitle className="sr-only">文件预览</DialogTitle>
        <DialogDescription className="sr-only">预览上传的文件</DialogDescription>
        <DialogHeader className="pb-2">
          <div className="flex justify-between items-center w-full">
            <DialogTitle></DialogTitle>
            <DialogClose asChild></DialogClose>
          </div>
        </DialogHeader>

        <div className="mt-4 flex justify-center items-center w-full h-[60vh] bg-gray-50 rounded-md overflow-auto">
          {/* Image Preview */}
          {previewType === "image" && previewItem?.url && (
            <div className="w-full h-full flex justify-center items-center p-4">
              <img
                src={previewItem.url}
                alt={previewItem.name || "预览图片"}
                className="max-w-full max-h-full object-contain"
              />
            </div>
          )}

          {/* Text Preview */}
          {previewType === "text" && previewItem?.originalFile && (
            <div className="w-full h-full overflow-auto p-4">
              <TextFilePreview file={previewItem.originalFile} />
            </div>
          )}

          {/* Other File Types */}
          {previewType === "other" && (
            <div className="flex flex-col items-center justify-center text-gray-500">
              <Link2Icon className="h-12 w-12 mb-2" />
              <p>不支持在线预览此文件类型</p>
              {previewItem?.url && (
                <Button
                  variant="default"
                  className="mt-2"
                  onClick={() => window.open(previewItem.url, "_blank")}
                >
                  在新窗口打开
                </Button>
              )}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
